export default {
  setSearchText (state: {[key:string]: string}, payload: string) {
    state.searchText = payload
  },
  setOrderName (state: {[key:string]: string}, name: string) {
    state.orderName = name
  },
  setSortAsc (state: {[key:string]: boolean}, sort: boolean) {
    state.sortAsc = sort
  },
  setIsValid (state: {[key:string]: number}, is_valid: number) {
    state.isValid = is_valid
  },
  setMachineType (state: {[key:string]: number}, machine_type: number) {
    state.machineType = machine_type
  }
}
